module.exports = __webpack_public_path__ + "img/transport_pic04.1a1fbf3e.png";